export const pittmeadowsTheme = {
  colors: {
    primary: 'rgba(167, 170, 56, 1)',
    primaryLight: 'rgba(227, 230, 149, 1)',
    primaryExtraLight: 'rgba(237, 239, 189, 1)',
    error: 'rgba(232, 76, 61, 1)',
    errorLight: 'rgba(232, 76, 61, 0.15)',
    white: '#FFFFFF',
    sectionDivider: '#CCCCCC',
    text: {
      body: '#666B66',
      heading: '#506173',
      link: 'rgba(0, 85, 140, 1)',
      linkDisabled: 'rgba(0, 85, 140, 0.6)'
    },
    primaryButton: {
      border: 'rgba(227, 230, 149, 1)',
      background: 'rgba(227, 230, 149, 1)',
      hover: 'rgba(167, 170, 56, 1)',
      disabled: 'rgba(227, 230, 149, 0.6)',
      text: '#515151',
      hoverText: '#FFFFFF',
      disabledText: 'rgba(51, 51, 51, 0.4)'
    },
    secondaryButton: {
      border: 'rgba(158, 158, 158, 1)',
      hoverBorder: 'rgba(158, 158, 158, 0.4)',
      background: '#FFFFFF',
      hover: '#F1F1F1',
      disabled: '#F7F7F7',
      text: 'rgba(80, 97, 115, 1)',
      disabledText: 'rgba(80, 97, 115, 0.8)'
    },
    inputField: {
      background: '#EEEEEE',
      border: '#3A3A3A',
      focusedBorder: 'rgba(167, 170, 56, 1)',
      text: '#666B66',
      placeholder: '#A6A6A6',
      disabledText: '#666B66aa'
    },
    background: {
      white: '#FFFFFF',
      light: '#F7F7F7',
      medium: '#EEEEEE',
      pageOverlay: 'rgba(85, 85, 85, 0.7)'
    }
  },
  borderRadius: {
    button: '8px',
    iconButton: '3px',
    div: '8px',
    input: '8px'
  },
  fonts: {
    heading: 'Montserrat, sans-serif',
    body: 'Montserrat, sans-serif'
  }
}
